export class Style {

    /**
     * Apply variables to a specific element
     * @param el
     * @param variables
     */
    static applyVariables(el, variables) {
        const variablesNames = Object.keys(variables);
        for (let i = 0; i < variablesNames.length; i++) {
            const name = variablesNames[i];
            el.style.setProperty('--' + name, variables[name]);
        }
    }
}